<button
  mat-flat-button
  class="scw-mat-button"
  [class.block]="block"
  [disabled]="disabled"
  [class.mat-cta]="type === 'cta'"
  [class.mat-standard]="type === 'standard'"
  [class.mat-danger]="type === 'danger'"
  [class.mat-ghost]="type === 'ghost'"
  [class.icon-button]="iconButton"
  [class.fab]="fab"
  [class.button-xs]="size === 'xs'"
  [class.button-sm]="size === 'sm'"
  [class.button-md]="size === 'md'"
  [class.button-lg]="size === 'lg'"
  [ngClass]="className"
  (click)="onClickEmitter()"
  [attr.form]="form"
>
  <ng-content></ng-content>
</button>
